import { Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/core/stores/auth.store';
import { useGuardBypass } from '../hooks/useGuardBypass';

export function AuthGuard() {
  const { t } = useTranslation('core');
  const bypass = useGuardBypass();
  const hasHydrated = useAuthStore((s) => s.hasHydrated);
  const tokens = useAuthStore((s) => s.tokens);
  const isTokenValid = useAuthStore((s) => s.isTokenValid);

  if (bypass) {
    return <Outlet />;
  }

  // Espera a que Zustand rehidrate desde localStorage
  if (!hasHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="text-muted-foreground text-sm">{t('loading')}</span>
      </div>
    );
  }

  // Sin tokens en absoluto → login directo
  if (!tokens) {
    return <Navigate to="/login" replace />;
  }

  // Hay refresh token aunque el access esté expirado
  // El interceptor de Axios hará el refresh en la primera llamada
  const hasRefreshToken = !!tokens.refreshToken;

  if (!isTokenValid() && !hasRefreshToken) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
